<template>
  <div>
    <div class="filter">
      <div class="row">
        <div class="col-12 text-center p-2">
          <hr>
          <span class="text-muted">
                Kopā atrasti <strong>{{total_count}}</strong> zinātniskie apraksti
              </span>
        </div>
      </div>
    </div>
    <div class="results">
      <div class="loader" v-show="loading">
        <img src="/images/loading.svg" rel="preload" alt="Notiek ielāde..">
      </div>
      <table class="table table-responsive-xl table-hover ">
        <thead class="bg-primary text-white">
        <tr>
          <th>Zinātniskais apraksts</th>
          <th>Zin. apr. pievienotājs</th>
          <th class="text-center">Darbības</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="description in descriptions" :key="description.id">

          <td style="white-space: pre-line;" class="small description">{{description.description}}</td>
          <td class="nowrap small">
            <span v-if="description.author">{{description.author.firstname}} {{description.author.lastname}}</span><span v-else>-</span><br />
            {{normalDate(description.created_at)}}
          </td>
          <td class="actions">
            <scientific-description-delete-mark-component :description="description" v-if="hasPermission(user,'can_move_scientific_description_delete_area')"></scientific-description-delete-mark-component>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="pagination" v-if="pagination.show_pagination">
        <div class="pages">
          <div class="page" @click="changePage(1)" v-if="pagination.show_first_page">1</div>
          <div class="delimiter" v-if="pagination.show_first_page_divider">...</div>
          <div class="page" @click="changePage(page)" v-for="page in pagination.prev_pages" :key="page">{{page}}</div>
          <div class="page currentPage"  :key="pagination.current_page">{{pagination.current_page}}</div>
          <div class="page" @click="changePage(page)" v-for="page in pagination.next_pages" :key="page">{{page}}</div>
          <div class="delimiter" v-if="pagination.show_last_page_divider">...</div>
          <div class="page" @click="changePage(pagination.total_page_count)" :key="pagination.total_page_count" v-if="pagination.show_last_page">{{pagination.total_page_count}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['list_type','user'],
  mounted() {
    var that = this;
    setTimeout(() => {
      this.getDescriptions();
    },30);
  },
  data()
  {
    return{
      descriptions:[],
      loading: true,
      filter_items_per_page:20,
      pagination:[],
      total_count:"",
    }
  },
  methods:{


    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    hasPermission(user,permission)
    {

      return user.allpermissions.some(function(p) {
        return p.name == permission;
      });
    },
    normalDate(date)
    {
      var d = moment(date).format('DD.MM.YYYY.');
      if(moment(d, 'DD.MM.YYYY.').isValid())
      {
        return d;
      }
      else
      {
        return null;
      }
    },
    getDescriptions(page = 1, scroll_top = true){
      this.loading = true;
      var that = this;
      var filterData = {
        page:page,
        items_per_page: that.filter_items_per_page,
        list_type: that.$props.list_type
      };
      axios.post('/dashboard/errors/get-scientific-descriptions',filterData)
          .then(response => {
            that.descriptions = response.data.descriptions;
            that.pagination = response.data.pagination;
            that.total_count = response.data.total_count;
            that.loading = false;
            if(scroll_top == true)
            {
              that.scrollToTop();
            }
          }).catch(err =>{

      })
    },

    changePage(page)
    {
      this.getDescriptions(page)
    },
  }


}
</script>

<style lang="scss" scoped>
@use "sass:color";
@import '../../../sass/variables';

.filter{
  padding: 20px;
  box-shadow: 0 1px 20px rgb(0 0 0 / 20%);
  margin-bottom: 10px;
}

.description{
  word-break: break-all;
}
.nowrap{
  white-space: nowrap;
}
.results{
  position:relative;
  .loader{
    cursor: progress;
    position:absolute;

    width:100%;
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
    background:rgba(255,255,255,0.7);
    img{
      width:100px;
      height:100px;
    }

  }
}
.pagination{
  margin-top:20px;
  padding-top:20px;
  border-top:solid 2px #777;
  .pages{
    display:flex;
    margin:auto;
    .page{
      width:32px;
      height:32px;
      margin:0 10px;
      display:flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-radius:100%;
      font-weight: 700;
      transition: all .2s ease-in-out;
      &:hover{
        background:$blue;
        color:#fff;
      }
    }
    .delimiter{
      width:20px;
      height:32px;
      margin:0 0px;
      display:flex;
      color:#333;
      align-items: center;
      justify-content: center;
    }
    .currentPage{
      background:$blue;
      color:#fff;
      cursor:auto;
    }

  }
}
</style>